<template>
  <div class="container">
    <span class="title is-3">{{ empresa.nombrec }}</span>
    <small class="title is-5"
      >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
    >
    <small class="subtitle is-7">{{ empresa.nombre }}</small>
    <hr />
    <div class="field is-grouped">
      <p class="control has-icons-left has-icons-right">
        <input
          class="input is-normal is-focused"
          type="text"
          v-model="search"
          placeholder="Buscar Productos"
        />
        <span class="icon is-medium is-left">
          <i class="material-icons">search</i>
        </span>
      </p>
      <div class="control">
        <div class="tags has-addons">
          <span class="tag is-medium has-background-grey-lighter"
            >Total Productos</span
          >
          <span class="tag is-info is-medium fontMono">{{
            pagination.count | number()
          }}</span>
        </div>
      </div>
      <div class="control">
        <button class="button is-link" @click="download">
          <span class="icon">
            <span class="material-icons"> download </span>
          </span>
          <span>Descargar</span>
        </button>
      </div>
    </div>
    <div v-if="showList">
      <h1 class="title">Productos</h1>
      <table class="table is-hoverable is-fullwidth is-narrow">
        <thead>
          <tr>
            <th>#</th>
            <th>Código</th>
            <th>Descripción</th>
            <th>Marca</th>
            <th>Linea</th>
            <th>Grupo</th>
            <th>Und</th>
            <th>Precio</th>
            <th v-for="(itemx, indexx) in bodegas" :key="indexx">
              {{ itemx.descripcion }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in products" :key="index">
            <td>{{ index + pagination.inicial * 20 + 1 }}</td>
            <td class="fontMono">
              <small
                ><strong>{{ item.codigo }}</strong></small
              >
            </td>
            <td>
              <small>{{ item.descripcion }}</small>
            </td>
            <td>
              <small>{{ item.marca }}</small>
            </td>
            <td>
              <small
                >{{ item.linea.codigo }} {{ item.linea.descripcion }}</small
              >
            </td>
            <td>
              <small
                >{{ item.grupo.codigo }} {{ item.grupo.descripcion }}</small
              >
            </td>
            <td>
              <small
                >{{ item.unidad.codigo }}
                <span style="font-size: 11px">{{
                  item.unidad.descripcion
                }}</span></small
              >
            </td>
            <td class="has-text-right">
              <span class="fontMono">{{ item.precios[0] | number() }}</span>
            </td>
            <td
              class="has-text-right fontMono"
              v-for="(itemx, indexx) in bodegas"
              :key="indexx"
            >
              {{
                item.datosProducto && item.datosProducto[itemx._id]
                  ? item.datosProducto[itemx._id].existencia.unidades
                  : 0 | number(2)
              }}
            </td>
            <td>
              <span
                class="icon has-text-info hand"
                @click="selectProduct(item)"
              >
                <i class="material-icons">find_in_page</i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <nav class="pagination" role="navigation" aria-label="pagination">
        <a class="pagination-previous" @click="previous">Anterior</a>
        <a class="pagination-previous">{{ pagination.inicial + 1 }}</a>
        <a class="pagination-next" @click="next">Siguiente</a>
        <ul class="pagination-list">
          <li>
            <a
              class="pagination-link"
              :class="pagination.inicial === 0 ? 'is-current' : ''"
              aria-label="Page 1"
              aria-current="page"
              @click="ir(0)"
              >1</a
            >
          </li>
          <li v-show="pagination.total > 1">
            <a
              class="pagination-link"
              :class="pagination.inicial === 1 ? 'is-current' : ''"
              aria-label="Goto page 2"
              @click="ir(1)"
              >2</a
            >
          </li>
          <li v-show="pagination.total > 2">
            <a
              class="pagination-link"
              :class="pagination.inicial === 2 ? 'is-current' : ''"
              aria-label="Goto page 3"
              @click="ir(2)"
              >3</a
            >
          </li>
          <li>
            <span class="pagination-ellipsis">&hellip;</span>
          </li>
          <li v-show="pagination.total > 5">
            <a
              class="pagination-link"
              :class="
                pagination.inicial === pagination.mitad - 1 ? 'is-current' : ''
              "
              @click="ir(pagination.mitad - 1)"
              >{{ pagination.mitad }}</a
            >
          </li>
          <li>
            <span class="pagination-ellipsis">&hellip;</span>
          </li>
          <li v-show="pagination.total > 4">
            <a
              class="pagination-link"
              :class="
                pagination.inicial === pagination.total - 1 ? 'is-current' : ''
              "
              aria-label="Goto page 47"
              @click="ir(pagination.total - 1)"
              >{{ pagination.total }}</a
            >
          </li>
        </ul>
      </nav>
    </div>
    <div v-if="showForm">
      <h1 class="title is-4">{{ titleform }}</h1>
      <div class="columns is-multiline">
        <div class="column">
          <strong>{{ product.codigo }}</strong>
          <span>{{ product.descripcion }}</span>
          <span>{{ product.marca }}</span>
          <span>${{ product.precio | number() }}</span>
          <hr />
          <div v-if="product.tDatosproduct">
            <div
              class="box"
              v-for="(idbodega, index) in product.bodegas"
              :key="index"
            >
              <div class="columns">
                <div class="column">
                  <strong>Bodega: </strong>
                  <strong class="fontMono">{{ nombreBodega(idbodega) }}</strong>
                </div>
                <div class="column">
                  <strong>Cantidad: </strong>
                  <span class="fontMono">{{
                    product.datosProducto[idbodega]
                      ? product.datosProducto[idbodega].existencia.unidades
                      : 0 | number(2)
                  }}</span>
                </div>
                <div class="column">
                  <strong>Unidad: </strong>
                  <span class="fontMono">{{
                    nombreUnidad(product.unidad)
                  }}</span>
                </div>
              </div>
              <div v-if="product.tLote && product.lote[idbodega]">
                <div
                  class="columns"
                  v-for="(lote, index1) in product.lote[idbodega].list"
                  :key="index1"
                >
                  <div class="column">
                    <span class="fontMono">Código {{ lote }}</span>
                  </div>
                  <div class="column">
                    <span class="fontMono"
                      >Nombre: {{ product.lote[idbodega][lote].nombre }}</span
                    >
                  </div>
                  <div class="column">
                    <span class="fontMono"
                      >Existencia:
                      {{
                        product.lote[idbodega][lote].existencia | number(2)
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="buttons">
        <button class="button is-link" @click="fshowList()">Regresar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
export default {
  data() {
    return {
      bodegas: [],
      showList: true,
      showForm: false,
      titleform: "Resumen Producto",
      pagination: {
        count: 0,
        inicial: 0,
        total: 0,
        mitad: 0,
      },
      search: "",
      products: [],
      grupos: [],
      product: {
        codigo: "",
        descripcion: "",
        marca: "",
        linea: "",
        grupo: "",
        unidad: "",
        precio: "",
        active: "",
        precios: "",
        tDatosproduct: false,
        tLote: false,
        bodegas: [],
      },
    };
  },
  computed: {
    ...mapState(["empresa"]),
  },
  methods: {
    async download() {
      try {
        let result = await apiServices.post(
          `/reporteinventario`,
          {},
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        let ahora = new Date();
        ahora = ahora.toISOString();
        link.setAttribute(`download`, `Productos-${ahora}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
    nombreBodega(idbodega) {
      let nombre;
      const _this = this;
      for (let index = 0; index < this.bodegas.length; index++) {
        if (this.bodegas[index]._id === idbodega) {
          nombre = `${_this.bodegas[index].codigo} - ${_this.bodegas[index].descripcion}`;
          break;
        }
      }
      return nombre;
    },
    nombreUnidad(idunidad) {
      let response;
      const _this = this;
      for (let index in this.unidad) {
        const und = _this.unidad[index];
        if (und._id === idunidad) {
          response = und.descripcion;
        }
      }
      return response;
    },
    async calculaProducto(idproducto) {
      try {
        const _this = this;
        let result;
        result = await apiServices.get(`/calculaproducto/${idproducto}`);
        if (result.data) {
          const bodegas = { list: [] };
          for (let index in result.data) {
            const res = result.data[index];
            if (bodegas.list.indexOf(res._id.bodega) === -1) {
              bodegas.list.push(res._id.bodega);
              bodegas[res._id.bodega] = {
                existencia: 0,
                lotes: {
                  list: [],
                },
              };
            }
            if (
              bodegas[res._id.bodega].lotes.list.indexOf(
                res._id.batchcodigo ? res._id.batchcodigo : "*"
              ) === -1
            ) {
              bodegas[res._id.bodega].lotes.list.push(
                res._id.batchcodigo ? res._id.batchcodigo : "*"
              );
              bodegas[res._id.bodega].lotes[
                res._id.batchcodigo ? res._id.batchcodigo : "*"
              ] = {
                name: res._id.batchnombre ? res._id.batchnombre : "-",
                existencia: 0,
              };
            }
            bodegas[res._id.bodega].lotes[
              res._id.batchcodigo ? res._id.batchcodigo : "*"
            ].existencia += res.valor;
            bodegas[res._id.bodega].existencia += res.valor;
          }
          for (let index in bodegas.list) {
            const idbodega = bodegas.list[index];
            if (
              _this.product.datosProducto &&
              _this.product.datosProducto[idbodega]
            ) {
              _this.product.datosProducto[idbodega].existencia.unidades =
                bodegas[idbodega].existencia;
            }
            if (this.product.tLote) {
              _this.product.lote[idbodega] = { list: [] };
              for (let index2 in bodegas[idbodega].lotes.list) {
                const codigolote = bodegas[idbodega].lotes.list[index2];
                if (bodegas[idbodega].lotes[codigolote].existencia !== 0) {
                  _this.product.lote[idbodega].list.push(codigolote);
                  _this.product.lote[idbodega][codigolote] = {
                    nombre: bodegas[idbodega].lotes[codigolote].name,
                    existencia: bodegas[idbodega].lotes[codigolote].existencia,
                  };
                }
              }
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    fshowForm(tipo) {
      this.showForm = true;
      this.showList = false;
    },
    fshowList() {
      this.showList = true;
      this.showForm = false;
      this.product = {
        codigo: "",
        descripcion: "",
        marca: "",
        linea: "",
        grupo: "",
        unidad: "",
        precio: "",
      };
      this.error = null;
    },
    async getBodegas() {
      try {
        this.bodegas = [];
        const result = await apiServices.get(`/bodegas`);
        this.bodegas = result.data;
      } catch (err) {
        console.log(err);
      }
    },
    async getUnidad() {
      try {
        let result;
        result = await apiServices.get(`/listunits`);
        this.unidad = functions.order(result.data, "codigo");
      } catch (err) {
        console.log(err);
      }
    },
    selectProduct(product) {
      const _this = this;
      _this.restoLprecios = [];
      const listasprecios = Object.keys(product.precios);
      this.product = {
        _id: product._id,
        codigo: product.codigo,
        descripcion: product.descripcion,
        marca: product.marca,
        linea: product.linea._id,
        grupo: product.grupo._id,
        unidad: product.unidad._id,
        precio: product.precios[0],
        active: product.active,
        precios: product.precios,
        bodegas: [],
      };
      if (product.datosProducto) {
        this.product.tDatosproduct = true;
        const bodegas = Object.keys(product.datosProducto);
        this.product.bodegas = bodegas;
        this.product.datosProducto = product.datosProducto;
        this.calculaProducto(product._id);
      } else {
        this.product.tDatosproduct = false;
      }

      if (product.lote) {
        this.product.tLote = true;
        this.product.lote = product.lote;
      } else {
        this.product.tLote = false;
      }

      listasprecios.forEach(function (k, v) {
        if (v !== 0) {
          _this.product.precios[k] = product.precios[k];
          _this.restoLprecios.push(k);
        }
      });
      this.fshowForm();
    },
    previous() {
      if (this.pagination.inicial > 0) {
        this.pagination.inicial--;
        this.find();
      }
    },
    next() {
      if (this.pagination.inicial + 1 < this.pagination.total) {
        this.pagination.inicial++;
        this.find();
      }
    },
    ir(n) {
      this.pagination.inicial = n;
      this.find();
    },
    async find() {
      try {
        const _this = this;
        const f = {
          search: _this.search,
          inicial: _this.pagination.inicial * 20,
        };
        let result;
        result = await apiServices.post(`/searchproducto`, f);
        _this.products = result.data.data;
        _this.pagination.count = result.data.count;
        _this.pagination.total = Math.ceil(_this.pagination.count / 20);
        _this.pagination.mitad = Math.round(
          (_this.pagination.total - 3) / 2 + 3
        );
        if (_this.products.length === 0) {
          _this.pagination.inicial = 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async recalcular() {
      try {
        await apiServices.get(`/recalcularproducto`);
        this.find();
      } catch (err) {
        console.log(err);
      }
    },
  },
  watch: {
    search(nv, ov) {
      this.find();
    },
  },
  created() {
    this.find();
    this.getUnidad();
    this.getBodegas();
    if (this.empresa._id !== "no id") {
      this.lote = this.empresa.lote;
    }
    this.recalcular();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/reports/inventario/Inventario.vue